import React from 'react'
import { MODEL_TYPE } from '@trustero/trustero-api-web/lib/common/model_pb'
import { TableListLoader } from 'src/components/Reusable/ContentLoaders/TableListLoader'
import { useChangeLogEntries } from './useChangeLogEntries'
import { EntriesContainer } from './Changelog.styles'
import { ChangeLogEntries } from './ChangeLogEntries'
import { CHANGELOG_PAGE_SIZE, EmptyLog } from './ChangelogPage.helpers'

// Only the most recent `itemsPerPage` entries are ever fetched/shown here — there is
// no "Load More" pagination. Anything beyond this page is reached via the "Show all"
// link, which navigates to the (filtered) Activities index page instead.
export const ChangelogPage = ({
  itemsPerPage = CHANGELOG_PAGE_SIZE,
  subjectModelIds,
  subjectIds,
  subjectType,
}: {
  itemsPerPage: number
  subjectModelIds?: string[]
  subjectIds?: string[]
  subjectType?: MODEL_TYPE
}): JSX.Element => {
  const { isLoading, data } = useChangeLogEntries(
    itemsPerPage,
    0,
    subjectModelIds,
    subjectIds,
    subjectType,
  )

  const page = data ? [...data] : []
  const pageLogEntries = page.length ? page[0].getActivityLogEntriesList() : []
  const noneToShow = page.length > 0 && pageLogEntries.length === 0

  if (isLoading && !page.length) {
    return <TableListLoader rows={3} />
  } else if (noneToShow || !page.length) {
    return <EmptyLog content="No activities to show." />
  }

  return (
    <EntriesContainer>
      <ChangeLogEntries entries={page[0]} />
    </EntriesContainer>
  )
}
